import type { ItemType } from './schema';

/**
 * Category colors shared with the World App (its map/theme.ts), so a hotel, a flight or a
 * drive looks the same in both apps.
 */
export const CATEGORY_COLOR = {
  city: '#E5484D',
  hotel: '#0EA5E9',
  restaurant: '#F97316',
  shop: '#3E7BFA',
  sight: '#8B5CF6',
  airport: '#7DD3FC',
  home: '#D97706',
  other: '#94A3B8',
  flight: '#7C9CFF',
  // Rental cars and driving them: orange (a lighter shade than restaurants).
  drive: '#FB923C',
  ride: '#FBBF24',
  train: '#C084FC',
  boat: '#22D3EE',
} as const;

export type Category = keyof typeof CATEGORY_COLOR;

/** The World App category a plan belongs to. */
export function categoryOf(type: ItemType): Category {
  switch (type) {
    case 'flight':
      return 'flight';
    case 'lodging':
      return 'hotel';
    case 'car':
    case 'parking':
      return 'drive';
    case 'transfer':
      return 'ride';
    case 'train':
    case 'bus':
      return 'train';
    case 'ferry':
    case 'cruise':
      return 'boat';
    case 'restaurant':
      return 'restaurant';
    case 'activity':
      return 'sight';
    default:
      return 'other';
  }
}
